/**
 * mobx hooks 类似于inject 用法：useStores(name)
 */

import React from 'react';
import { MobXProviderContext } from 'mobx-react';
const useStores = name => React.useContext(MobXProviderContext)[name];

export default useStores;
